module.exports = __webpack_public_path__ + "static/media/user_1.04923ff9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/images/users/user_1.jpg
// module id = 486
// module chunks = 0